import { render, staticRenderFns } from "./ServiceDetail.vue?vue&type=template&id=e3120426&scoped=true"
import script from "./ServiceDetail.vue?vue&type=script&lang=js"
export * from "./ServiceDetail.vue?vue&type=script&lang=js"
import style0 from "./ServiceDetail.vue?vue&type=style&index=0&id=e3120426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3120426",
  null
  
)

export default component.exports